<div *ngIf="this.NgFormGroup != null"
     class="edit-workflow-div">
    <form *ngIf="this.NgFormGroup != null"
          matForm [formGroup]="this.NgFormGroup"
          (ngSubmit)="this.onSave()">
        <div class="historyPanel mat-small">
            <div *ngIf="workflow.createdDate">
                <strong>created</strong> {{ workflow.createdDate | date: 'MMM d, YYYY, h:mm:ss a' }}
                <span *ngIf="workflow.createdByUserName"><br />by {{ workflow.createdByUserName }}</span>
            </div>
            <div *ngIf="workflow.modifiedDate > workflow.createdDate">
                <strong>modified</strong> {{ workflow.modifiedDate | date: 'MMM d, YYYY, h:mm:ss a' }}
                <span *ngIf="workflow.modifiedByUserName"><br />by {{ workflow.modifiedByUserName }}</span>
            </div>
        </div>
        <div class="name-div">
            <mat-form-field appearance="outline"
                            [floatLabel]="'always'"
                            class="name-mat-form-field">
                <mat-label>Name</mat-label>
                <input matInput placeholder="Name" formControlName="name" required>
            </mat-form-field>
        </div>

        <div class="description-div">
            <mat-form-field appearance="outline"
                            [floatLabel]="'always'"
                            class="description-mat-form-field">
                <mat-label>Description</mat-label>
                <textarea matInput formControlName="description"></textarea>
            </mat-form-field>
        </div>

        <div class="action-buttons-div">
            <button mat-raised-button type="submit"
                    color="primary"
                    [disabled]="this.FormInvalid">
                Save
            </button>

            <button mat-raised-button type="button"
                    class="cancel-button"
                    (click)="this.onClose()">
                Cancel
            </button>
        </div>
    </form>
</div>
